// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".node-container .node-item[data-v-c7cff04c] {\n  line-height: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
